
import { ReactNode } from "react";
import { DashboardSidebar } from "./DashboardSidebar";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { useSidebarContext } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";

interface DashboardLayoutProps {
  children?: ReactNode;
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { isCollapsed } = useSidebarContext();
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex w-full bg-gradient-to-br from-background via-muted/30 to-background">
      <DashboardSidebar />
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
        !isMobile && (isCollapsed ? 'md:ml-[70px]' : 'md:ml-[240px]')
      }`}>
        <Navbar />
        <main className="flex-1 p-3 sm:p-4 md:p-6 lg:p-8 overflow-x-hidden">
          <div className="mx-auto w-full max-w-[1400px] animate-fade-in">
            {children || <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );
};
